<div class="bg-light fixed-top">
  <nav class="navbar navbar-light container navbar-expand-lg nav-height">
    <a class="navbar-brand pr-40px mr-0" href="/">
      <img src="../../../../assets/images/logo.svg" alt="logo" title="logo">
    </a>
  </nav>
</div>
<div class="align-center success-box">
  <img class="logo" src="../../../assets/images/itaxapp-qrcode-2025.webp" alt="qrcode" title="qrcode"/>
  <span class="header">แสกน QR code นี้ด้วยกล้องมือถือเพื่อดาวน์โหลดแอป iTAX</span>
</div>
